import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eaa9c62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NovoGrupo__Titulo" }

import { LPadrao } from "@/layouts/"
  import { TNovoGrupo, ODadosGrupo } from "@/components/Projetos/"
  import {
    IAlertaMensagem,
    OTrilhaDeNavegacao,
    MModalDeAlerta,
  } from "@/components/Gerais"
  import { computed, ref, onBeforeMount, reactive } from "vue"
  import { MenuItem } from "primevue/menuitem"
  import useVuelidate from "@vuelidate/core"

  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"

  import { EntidadeGenerica } from "@/types/gerais"
  import { ListarProjetos } from "@/repositorios/projeto/projeto.modelo"
  import { OSelecionarProjetosGrupo } from "@/components/Projetos"
  import {
    ListarUsuarios,
    ParamsUsuario,
  } from "@/repositorios/usuarios/usuarios.modelo"
  import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
  import { CriarGrupoDeProjetos } from "@/repositorios/gruposDeProjetos/gruposDeProjetos.modelo"
  import GruposDeProjetosRepositorio from "@/repositorios/gruposDeProjetos/gruposDeProjetos.repositorio"

  import { useRouter } from "vue-router"
  import { useI18n } from "vue-i18n"

  interface AlertaComReset extends IAlertaMensagem {
    $reset(): void
    legendaBotaoPositivo?: string
    acaoBotaoPositivo?: () => void
    legendaBotaoNeutro?: string
    acaoBotaoNeutro?: () => void
    legendaBotaoNegativo?: string
    acaoBotaoNegativo?: () => void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NovoGrupo',
  setup(__props) {

  const { t } = useI18n()

  const home = ref<MenuItem>({
    label: t("projetos"),
    icon: "pi pi-calendar",
    to: "/",
  })

  const breadCrumbItems = ref<MenuItem[]>([
    {
      label: t("criarGrupoDeProjetos"),
      to: "/novo-grupo",
    },
  ])

  const objetoDialog = reactive<AlertaComReset>({
    icone: "pi pi-exclamation-triangle",
    titulo: t("cancelarCriacaoDoGrupoDeProjetos"),
    tipo: "atencao",
    visivel: false,
    conteudo: t("aoCancelarVocePerderaTodasAsInformacoesNaoSalvas"),
    $reset: function () {
      this.visivel = false
      this.titulo = ""
      this.tipo = "padrao"
      this.conteudo = ""
    },
  })

  const escopoValidacao = "novo_grupo"
  const v$ = useVuelidate({ $scope: escopoValidacao })

  const usuariosRepositorio = new UsuariosRepositorio()
  const gruposDeProjetosRepositorio = new GruposDeProjetosRepositorio()

  const { leitor } = usarLeitorDeDados()
  const { colher } = usarManipuladorObjetos()
  const { onErro, onSucesso } = usarMensagemUsuario()
  const { escritor, resolver } = usarEscritorDeDados()

  const router = useRouter()

  const lerUsuarios = leitor<ListarUsuarios, ParamsUsuario>(
    usuariosRepositorio.listarUsuarios,
    {
      "por-pagina": "1000",
    }
  )

  const criarGrupoDeProjetosEscritor = escritor<
    { id: string },
    CriarGrupoDeProjetos
  >(gruposDeProjetosRepositorio.criarGrupoDeProjetos, [])

  const nomeDoGrupo = ref<string>("")
  const usuariosResponsaveis = ref<string[]>([])
  const usuariosResponsaveisOpcoes = ref<EntidadeGenerica[]>([])
  const projetosSelecionados = ref<ListarProjetos[]>([])

  const submissaoPendente = computed(() => {
    return criarGrupoDeProjetosEscritor.resultado.status === "pendente"
  })

  const estaCarregandoUsuariosResponsaveis = computed(() => {
    return lerUsuarios.resultado.status === "pendente"
  })

  const criarGrupoDeProjetos = async (
    parametros: CriarGrupoDeProjetos
  ): Promise<void> => {
    criarGrupoDeProjetosEscritor.mudarArgumentos([parametros])
    await criarGrupoDeProjetosEscritor.executar()

    resolver<{ id: string }>(criarGrupoDeProjetosEscritor.resultado, {
      sucesso: () => {
        onSucesso({
          resumo: t("grupoDeProjetosCriadoComSucesso"),
          detalhes: t("vocePodeAcessaLoNoMenuEsquerda"),
        })
        router.push("/projetos")
      },
      erro: () => {
        onErro({
          resumo: t("erroAoCriarGrupoDeProjetos"),
          detalhes: t("ocorreuUmErroAoCriarGrupoDeProjetos")
        })
      },
    })
  }

  const mapearIdsDeProjetos = (projetos: ListarProjetos[]): string[] => {
    return projetos.map((projeto) => projeto.id)
  }

  const submeterGrupoDeProjetos = (): void => {
    v$.value.$touch()

    const parametrosDoGrupoDeProjetos: CriarGrupoDeProjetos = {
      nome: nomeDoGrupo.value,
      idsUsuariosResponsaveis: usuariosResponsaveis.value,
      idsProjetos: mapearIdsDeProjetos(projetosSelecionados.value),
    }

    criarGrupoDeProjetos(parametrosDoGrupoDeProjetos)
  }

  const abrirModalDeConfirmacao = (): void => {
    objetoDialog.titulo = t("cancelarCriacaoDoGrupoDeProjetos")
    objetoDialog.conteudo = t("aoCancelarVocePerderaTodasAsInformacoesNaoSalvas")
    objetoDialog.tipo = "atencao"
    objetoDialog.visivel = true
    objetoDialog.legendaBotaoNeutro = t("voltarEditar")
    objetoDialog.acaoBotaoNeutro = (): void => objetoDialog.$reset()
    objetoDialog.legendaBotaoPositivo = t("simCancelar")
    objetoDialog.acaoBotaoPositivo = (): void => cancelarProjeto()
  }

  const cancelarProjeto = (): void => {
    objetoDialog.visivel = false
    router.push("/projetos")
  }

  const listarUsuariosResponsaveis = async (): Promise<void> => {
    await lerUsuarios.executar()

    if (lerUsuarios.resultado.status === "sucesso") {
      usuariosResponsaveisOpcoes.value = colher<
        ListarUsuarios,
        { id: string; nome: string }
      >(lerUsuarios.resultado.dados, ["id", "nome"])
    }

    if (lerUsuarios.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoBuscarOsUsuariosResponsaveis"),
        detalhes: t("ocorreuUmErroAoBuscarOsUsuariosResponsaveis")
      })
    }
  }

  const carregarDadosModoCriar = async (): Promise<void> => {
    await listarUsuariosResponsaveis()
  }

  onBeforeMount(async () => {
    await carregarDadosModoCriar()
  })

return (_ctx: any,_cache: any) => {
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createBlock(_unref(LPadrao), {
    class: "NovoGrupo",
    "data-testid": "NovoGrupo"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TNovoGrupo), null, {
        titulo: _withCtx(() => [
          _createVNode(_unref(OTrilhaDeNavegacao), {
            "inicio-da-trilha": home.value,
            "itens-da-trilha": breadCrumbItems.value
          }, null, 8, ["inicio-da-trilha", "itens-da-trilha"])
        ]),
        campos: _withCtx(() => [
          _createVNode(_unref(ODadosGrupo), {
            "nome-grupo": nomeDoGrupo.value,
            "onUpdate:nome-grupo": _cache[0] || (_cache[0] = ($event: any) => ((nomeDoGrupo).value = $event)),
            "usuarios-responsaveis": usuariosResponsaveis.value,
            "onUpdate:usuarios-responsaveis": _cache[1] || (_cache[1] = ($event: any) => ((usuariosResponsaveis).value = $event)),
            "escopo-validacao": escopoValidacao,
            "esta-carregando-usuarios-responsaveis": 
            _unref(estaCarregandoUsuariosResponsaveis)
          ,
            "usuarios-responsaveis-opcoes": usuariosResponsaveisOpcoes.value
          }, null, 8, ["nome-grupo", "usuarios-responsaveis", "esta-carregando-usuarios-responsaveis", "usuarios-responsaveis-opcoes"])
        ]),
        centro: _withCtx(() => [
          _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)('selecionarProjetosParaAdicionarAoGrupo')), 1),
          _createVNode(_unref(OSelecionarProjetosGrupo), {
            "projetos-selecionados": projetosSelecionados.value,
            "onUpdate:projetos-selecionados": _cache[2] || (_cache[2] = ($event: any) => ((projetosSelecionados).value = $event)),
            "data-testid": "NovoGrupo__TabelaDeAdicaoDeProjetos",
            "projetos-pre-selecionados": [],
            "usuarios-responsaveis-opcoes": usuariosResponsaveisOpcoes.value
          }, null, 8, ["projetos-selecionados", "usuarios-responsaveis-opcoes"])
        ]),
        acoes: _withCtx(() => [
          _createVNode(_component_PButton, {
            onClick: submeterGrupoDeProjetos,
            class: "NovoGrupo__Botao NovoGrupo__Salvar p-button-success",
            "data-testid": "NovoGrupo__BotaoSalvar",
            disabled: _unref(v$).$invalid || _unref(submissaoPendente),
            label: _unref(t)('salvar'),
            loading: _unref(submissaoPendente)
          }, null, 8, ["disabled", "label", "loading"]),
          _createVNode(_component_PButton, {
            onClick: abrirModalDeConfirmacao,
            class: "NovoGrupo__Botao p-button-danger",
            "data-testid": "NovoGrupo__BotaoCancelar",
            disabled: _unref(submissaoPendente),
            label: _unref(t)('cancelar')
          }, null, 8, ["disabled", "label"])
        ]),
        modais: _withCtx(() => [
          _createVNode(_unref(MModalDeAlerta), {
            modelValue: objetoDialog.visivel,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((objetoDialog.visivel) = $event)),
            cabecalho: objetoDialog.titulo,
            "data-testid": "NovoGrupo__Alerta",
            tipo: objetoDialog.tipo
          }, {
            conteudo: _withCtx(() => [
              _createTextVNode(_toDisplayString(objetoDialog.conteudo), 1)
            ]),
            acoes: _withCtx(() => [
              (objetoDialog.acaoBotaoNeutro)
                ? (_openBlock(), _createBlock(_component_PButton, {
                    key: 0,
                    onClick: objetoDialog.acaoBotaoNeutro,
                    class: "NovoGrupo__Botao p-button-text",
                    "data-testid": "NovoGrupo__BotaoVoltar",
                    disabled: _unref(submissaoPendente),
                    label: objetoDialog.legendaBotaoNeutro,
                    loading: _unref(submissaoPendente)
                  }, null, 8, ["onClick", "disabled", "label", "loading"]))
                : _createCommentVNode("", true),
              (objetoDialog.acaoBotaoPositivo)
                ? (_openBlock(), _createBlock(_component_PButton, {
                    key: 1,
                    onClick: objetoDialog.acaoBotaoPositivo,
                    class: "NovoGrupo__Botao p-button-danger",
                    "data-testid": "NovoGrupo__BotaoConfirmar",
                    disabled: _unref(submissaoPendente),
                    label: objetoDialog.legendaBotaoPositivo
                  }, null, 8, ["onClick", "disabled", "label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "cabecalho", "tipo"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})